<div class="icon-picker">
  <div class="icon-picker-top">
    <span>Icon</span>
    <div class="import-btn">
      <label class="import-label">
        Import
        <input type="file" accept=".svg" (change)="onFileSelected($event)" hidden>
      </label>
    </div>
  </div>
  <div class="preview">
    <img *ngIf="!importedIcon" [src]="selectedIcon" alt="Selected Icon" />
    <img *ngIf="importedIcon" [src]="importedIcon" alt="Imported Icon" />
  </div>

  <div class="icon-list">
    <img 
      *ngFor="let icon of icons" 
      [src]="icon" 
      [class.selected]="icon === selectedIcon && !importedIcon"
      (click)="selectIcon(icon)" 
    />
  </div>

</div>
